
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import mixin from 'helpers/vuex-mixin'

import config from './config'
import date from './date'
import router from './router'
import version from './version'

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store(mixin({
  mixins: [config, date, router, version],
  strict: debug,
}))
